import PropTypes from 'prop-types';
import React from 'react';
import Flexbox from 'flexbox-react';
import { css } from 'emotion';

const spinner = css`
    border: 3px solid #f3f3f3;
    animation: spin 1s linear infinite;
    border-top: 3px solid #555;
    border-radius: 50%;
    width: 20px;
    height: 20px;
`;

export default class LoadingSpinner extends React.Component {

    static propTypes = {
        className: PropTypes.string
    };

    render() {
        return (
            <Flexbox className={this.props.className} flexDirection="row" alignItems="center">
                <div className={spinner}/>
                <div style={{ marginLeft: '5px' }}>Loading...</div>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/LoadingSpinner.js